module.exports = __webpack_public_path__ + "static/img/statusCorrectPoppy.79e67335.gif";